import { Client } from "types";

export const KUBRA_CLIENT_ID = "kubra_client_id";
export const KUBRA_CLIENT_CODE = "kubra_client_code";
export const KUBRA_CLIENT_NAME = "kubra_client_name";

export const kubraAnalytics = {
  setClient(client: Client | undefined) {
    if (client === undefined) {
      this.clearClient();
    } else {
      sessionStorage.setItem(KUBRA_CLIENT_ID, client.id);
      sessionStorage.setItem(KUBRA_CLIENT_CODE, client.code);
      sessionStorage.setItem(KUBRA_CLIENT_NAME, client.name);
    }
  },
  clearClient() {
    sessionStorage.removeItem(KUBRA_CLIENT_ID);
    sessionStorage.removeItem(KUBRA_CLIENT_CODE);
    sessionStorage.removeItem(KUBRA_CLIENT_NAME);
  },
};
